import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  align-items: center;
  padding: ${(props) => (props.size === 'small' ? '0' : '0 0 1.6rem 0')};
  gap: 1.6rem;
`;

export const Icon = styled.div`
  flex-shrink: 0;
`;

export const SubHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${(props) => (props.size === 'small' ? '1.6rem 0 0' : '0')};
`;

export const ContentFilter = styled.div`
  h6 {
    margin-bottom: 0;
  }
`;

export const ContentAction = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
`;
